import toast from 'react-hot-toast';

const toastStyle = {
  background: '#fcfcfc',
  color: '#000',
  paddingRight: '32px',
};


const SMALL_WORDS = new Set(["from", "to", "of", "and"]);

const toTitleCase = (str) => {
  if (!str) return str;
  return String(str).replace(/\S+/g, (word, offset) => {
    if (word === word.toUpperCase() && /[A-Z]/.test(word)) return word;
    const lower = word.toLowerCase();
    if (offset > 0 && SMALL_WORDS.has(lower)) return lower;
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  });
};


function alertErrorMessage(message) {
  toast.error(
    (t) => (
      <>
      <span>
        {message || 'Network error. Please try again later.'}
      </span>
       {/* <span style={closeCss} onClick={() => toast.dismiss(t.id)}><i class="ri-close-circle-line"></i></span> */}
       </>
    ),
    { position: 'top-center', style: toastStyle }
  );
}

function alertSuccessMessage(message) {
  toast.success(
    (t) => (
      <> 
      <span >
        {toTitleCase(message) || 'Success'}
      </span>
        {/* <span style={closeCss} onClick={() => toast.dismiss(t.id)}><i class="ri-close-circle-line"></i></span> */}
        </>
    ),
    { position: 'top-center', style: { ...toastStyle, maxWidth: '32rem' } }
  );
}

function alertMessage(message) {
  toast.success(
    (t) => (
      <> 
      {message || 'Success'}
        </>
    ),
    { position: 'bottom-right', style: toastStyle, duration: 1000,  }
  );
}

function alertWarningMessage(message) {
  toast(
    (t) => (
     <> <span >
        {message || 'Something went wrong.'}
      </span>
       {/* <span style={closeCss} onClick={() => toast.dismiss(t.id)}><i class="ri-close-circle-line"></i></span> */}
       </>
    ),
    { position: 'top-center', icon: '⚠️', style: toastStyle }
  );
}

export { alertErrorMessage, alertSuccessMessage, alertWarningMessage, alertMessage };

